var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreSales({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "11.47 11.47 177.061 177.061",
    viewBox: "11.47 11.47 177.061 177.061",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100 11.47c-48.894 0-88.53 39.637-88.53 88.531s39.637 88.53 88.53 88.53c48.894 0 88.531-39.636 88.531-88.53S148.894 11.47 100 11.47zm10.852 131.68v13.074H92.29v-12.87c-11.722-2.015-19.122-7.804-23.339-12.608l-1.929-2.209 10.178-12.83 2.782 3.125c2.799 3.158 8.898 8.597 18.365 9.559l6.35-.117c10.617-.891 11.454-7.434 11.454-9.417 0-4.543-3.066-7.011-12.148-9.781l-6.89-1.803c-9.956-2.635-26.614-7.045-26.614-24.728 0-11.784 8.804-21.159 21.791-23.977V43.777h18.562v15.11c7.642 1.656 14.34 5.222 19.443 10.646l2.113 2.251-10.333 12.6-2.736-3.075c-3.648-4.121-8.772-6.756-14.809-7.618l-1.305-.201-4.037-.155-1.071.046c-6.371.347-10.676 3.803-10.676 8.588 0 3.472 3.121 5.652 11.513 8.032l.586.201 6.388 1.627c10.149 2.857 27.049 7.618 27.049 26.221 0 10.317-5.927 21.869-22.125 25.1z",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreSales);
export default __webpack_public_path__ + "static/media/more_sales.18886346052a4e83736f4e7a831e1a57.svg";
export { ForwardRef as ReactComponent };